import { render, staticRenderFns } from "./CommonTab.vue?vue&type=template&id=d1e1044a&scoped=true"
import script from "./CommonTab.vue?vue&type=script&setup=true&lang=js"
export * from "./CommonTab.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CommonTab.vue?vue&type=style&index=0&id=d1e1044a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1e1044a",
  null
  
)

export default component.exports